<template>
  <section id="services" class="section services">
    <div class="container">
      <div class="section-head">
        <p v-reveal class="eyebrow"><span class="eyebrow__index">02</span>What we do</p>
        <h2 v-reveal="80" class="section-title">From the&nbsp;first contract to&nbsp;production</h2>
      </div>
      <ul class="services__grid">
        <li v-for="(item, i) in items" :key="i" v-reveal="i * 90" class="service-card">
          <span class="service-card__icon" v-html="item.icon"></span>
          <h3 class="service-card__title">{{ item.title }}</h3>
          <p class="service-card__text">{{ item.text }}</p>
          <ul class="tags">
            <li v-for="tag in item.tags" :key="tag">{{ tag }}</li>
          </ul>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
const icon = paths =>
  `<svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`

export default {
  name: 'Services',
  data() {
    return {
      items: [
        {
          title: 'Smart contracts',
          text: 'Tokens, NFT collections, staking and vesting contracts with marketplace mechanics on the blockchain level.',
          tags: ['ERC-20', 'ERC-721', 'BEP-20', 'Proxy'],
          icon: icon(
            '<path d="M7 3h10l5 5v17H7z"/><path d="M17 3v5h5"/><path d="M12 14l-2.5 2.5L12 19M17 14l2.5 2.5L17 19"/>'
          )
        },
        {
          title: 'DeFi & cross-chain',
          text: 'Liquidity bridges, cross-chain routers and DeFi protocols: stablecoins, lending and collateral insurance.',
          tags: ['deBridge', 'EVM', 'Stablecoins'],
          icon: icon(
            '<circle cx="7" cy="14" r="4"/><circle cx="21" cy="14" r="4"/><path d="M11 12h6M11 16h6"/><path d="M15 10l2 2-2 2"/>'
          )
        },
        {
          title: 'Web3 front-ends',
          text: 'Landing pages and dApps with crypto wallet connection, whitelists, pre-sales and minting flows.',
          tags: ['Wallets', 'IPFS', 'OpenSea'],
          icon: icon(
            '<rect x="3" y="5" width="22" height="18" rx="2"/><path d="M3 10h22"/><circle cx="7" cy="7.5" r=".5" fill="currentColor"/><path d="M16 15h6v4h-6a2 2 0 010-4z"/>'
          )
        },
        {
          title: 'Audit & analytics',
          text: 'Smart contract audits, on-chain monitoring, statistics dashboards and Telegram bots with instant alerts.',
          tags: ['Audit', 'Monitoring', 'Bots'],
          icon: icon(
            '<path d="M14 3l9 4v6c0 6-4 10-9 12-5-2-9-6-9-12V7z"/><path d="M10 14l3 3 5-6"/>'
          )
        }
      ]
    }
  }
}
</script>
